document.addEventListener('DOMContentLoaded', function(){
  var header = document.querySelector('[data-site-header]');
  function onScroll(){ if(header) header.classList.toggle('is-scrolled', window.scrollY > 30); }
  onScroll(); window.addEventListener('scroll', onScroll, {passive:true});

  var menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  if(menuToggle && mobileMenu){ menuToggle.addEventListener('click', function(){ var open = mobileMenu.hasAttribute('hidden'); if(open){ mobileMenu.removeAttribute('hidden'); } else { mobileMenu.setAttribute('hidden',''); } menuToggle.setAttribute('aria-expanded', String(open)); }); }

  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchBar = document.querySelector('[data-search-bar]');
  var searchClose = document.querySelector('[data-search-close]');
  function openSearch(){ if(searchBar){ searchBar.removeAttribute('hidden'); var input = searchBar.querySelector('input'); if(input) input.focus(); } }
  function closeSearch(){ if(searchBar) searchBar.setAttribute('hidden',''); }
  if(searchToggle) searchToggle.addEventListener('click', openSearch);
  if(searchClose) searchClose.addEventListener('click', closeSearch);

  var splash = document.querySelector('[data-splash-screen]');
  var enter = document.querySelector('[data-splash-enter]');
  if(splash && enter){ document.body.style.overflow = 'hidden'; enter.addEventListener('click', function(){ sessionStorage.setItem('sikoEntered','true'); splash.classList.add('is-fading'); document.body.style.overflow = ''; setTimeout(function(){ splash.remove(); }, 850); }); }

  var revealEls = document.querySelectorAll('.reveal-on-scroll');
  if('IntersectionObserver' in window){ var obs = new IntersectionObserver(function(entries){ entries.forEach(function(entry){ if(entry.isIntersecting){ entry.target.classList.add('is-visible'); obs.unobserve(entry.target); } }); }, {threshold:.12}); revealEls.forEach(function(el){ obs.observe(el); }); } else { revealEls.forEach(function(el){ el.classList.add('is-visible'); }); }
// Product image gallery controls
(function(){
  var galleries = document.querySelectorAll('[data-product-gallery]');
  galleries.forEach(function(gallery){
    var track = gallery.querySelector('[data-product-media-track]');
    var slides = gallery.querySelectorAll('[data-product-media-slide]');
    var thumbs = gallery.querySelectorAll('[data-product-thumb]');
    if(!track || !slides.length || !thumbs.length) return;
    function setActive(index){
      thumbs.forEach(function(thumb, i){ thumb.classList.toggle('is-active', i === index); });
    }
    function getIndex(){
      return Math.max(0, Math.min(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)), slides.length - 1));
    }
    function goTo(index){
      var next = (index + slides.length) % slides.length;
      if(slides[next]) slides[next].scrollIntoView({behavior:'smooth', block:'nearest', inline:'start'});
      setActive(next);
    }
    thumbs.forEach(function(thumb){
      thumb.addEventListener('click', function(){
        goTo(Number(thumb.getAttribute('data-product-thumb')) || 0);
      });
    });
    slides.forEach(function(slide){
      slide.addEventListener('click', function(){ goTo(getIndex() + 1); });
    });
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if(prev) prev.addEventListener('click', function(event){ event.stopPropagation(); goTo(getIndex() - 1); });
    if(next) next.addEventListener('click', function(event){ event.stopPropagation(); goTo(getIndex() + 1); });
    track.addEventListener('scroll', function(){
      setActive(getIndex());
    }, {passive:true});
  });
})();
});
// Delegated gallery click fallback for Shopify section reloads
(function(){
  document.addEventListener('click', function(event){
    var arrow = event.target.closest('[data-gallery-prev], [data-gallery-next]');
    var slide = event.target.closest('[data-product-media-slide]');
    if(!arrow && !slide) return;
    var gallery = event.target.closest('[data-product-gallery]');
    if(!gallery) return;
    var track = gallery.querySelector('[data-product-media-track]');
    var slides = gallery.querySelectorAll('[data-product-media-slide]');
    var thumbs = gallery.querySelectorAll('[data-product-thumb]');
    if(!track || !slides.length) return;
    event.preventDefault();
    event.stopPropagation();
    var current = Math.max(0, Math.min(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)), slides.length - 1));
    var target = current + 1;
    if(arrow && arrow.hasAttribute('data-gallery-prev')) target = current - 1;
    if(arrow && arrow.hasAttribute('data-gallery-next')) target = current + 1;
    target = (target + slides.length) % slides.length;
    slides[target].scrollIntoView({behavior:'smooth', block:'nearest', inline:'start'});
    thumbs.forEach(function(thumb, i){ thumb.classList.toggle('is-active', i === target); });
  }, true);
})();